import $ from "jquery";

import Handlebars from '../libraries/handlebars';
import convertPriceByCurrency from './convertPriceByCurrency';
import merchelloUi from '../libraries/merchello.ui';
import basketFormInit from "../modules/basketFormInit";

export default function () {
    var MUI = merchelloUi();
    const basketItemTemplate = Handlebars.compile($('#basket-item-handlebars-template').html());

    Init();

    function Init() {
        $('[data-muifrm="basket"]').find(':input[data-muiaction="updatequantity"]').change(function (event) {

            var frmRef = $(this).closest('form');
            var quantity = $(this).val();

            var tr = $(this).closest('tr');
            if (tr.length <= 0)
                return;

            var discountType = tr.find('input[name="discountType"]').val()

            if (discountType === 'PriceForItself') {
                DiscountForPriceForItself(frmRef, tr, quantity);
            }

            if (discountType === 'PriceForAnother') {
                DiscountForPriceForAnother(frmRef, tr, quantity, event);
            }

            if (discountType === 'Gift') {
                DiscountForGift(frmRef, tr, quantity);
            }

            if (discountType === 'Wholesale') {
                DiscountForWholesale(frmRef, tr, quantity);
            }
        });
    }

    function DiscountForPriceForItself(frmRef, tablRow, quantity) {

        var totalOldPrice = tablRow.find('#total-old-price');
        var priceWithoutDiscount = parseFloat(tablRow.find('#old-price').text()) * quantity;

        if (totalOldPrice.length > 0) {
            $(totalOldPrice).html(priceWithoutDiscount % 1 == 0 ? priceWithoutDiscount.toFixed(0) : priceWithoutDiscount.toFixed(2));
        }

        var sku = tablRow.find('input[name="sku"]').val();
        if (!sku)
            return;

        var $numberProductsForDiscount = tablRow.find('#numberProductsForDiscount');
        var $isDiscountApply = tablRow.find('#isDiscountApply');

        var numberProductsForDiscount = parseInt($numberProductsForDiscount.val());

        if (quantity < numberProductsForDiscount && $isDiscountApply.val() === 'False') {
            return;
        }

        if (quantity >= numberProductsForDiscount && $isDiscountApply.val() === 'True') {
            return;
        }

        const token = frmRef.find('input[name="__RequestVerificationToken"]').val();

        $.ajax({
            url: '/umbraco/Surface/Discount/UpdatePrice',
            type: 'PATCH',
            data: {
                sku,
                quantity,
                __RequestVerificationToken: token
            },
            async: false,
            success: function (data) {

                if (!data.Item) {
                    return;
                }

                var inputElement = $('input[name="sku"]').filter(function () {
                    return $(this).val() === data.Item.Sku;
                });

                const $currentTablRow = inputElement.closest('tr');

                var price = $currentTablRow.find('#price');
                if (price.length > 0) {
                    const itemPrice = convertPriceByCurrency(data.Item.Price);
                    $(price).html(itemPrice);
                }

                var oldPrice = $currentTablRow.find('#old-price').parent();
                var totalPrice = $currentTablRow.find('#total-price').parent();

                if (!data.IsConditionsFulfilled) {
                    price.parent().removeClass("new-price");
                    totalPrice.removeClass("new-price");

                    oldPrice.hide();
                    totalOldPrice.parent().hide();

                    $isDiscountApply.val('False');

                    return;
                }

                $isDiscountApply.val('True');

                price.parent().addClass("new-price");
                totalPrice.addClass("new-price");

                oldPrice.show();
                totalOldPrice.parent().show();
            }
        });
    }

    function DiscountForPriceForAnother(frmRef, tablRow, quantity, event) {

        var totalOldPrice = tablRow.find('#total-old-price');
        var priceWithoutDiscount = parseFloat(tablRow.find('#old-price').text()) * quantity;

        if (totalOldPrice.length > 0) {
            $(totalOldPrice).html(priceWithoutDiscount % 1 == 0 ? priceWithoutDiscount.toFixed(0) : priceWithoutDiscount.toFixed(2));
        }

        var sku = tablRow.find('input[name="sku"]').val();
        if (!sku)
            return;

        const token = frmRef.find('input[name="__RequestVerificationToken"]').val();

        $.ajax({
            url: '/umbraco/Surface/Discount/UpdatePricePerQuantity',
            type: 'PATCH',
            data: {
                sku,
                quantity,
                __RequestVerificationToken: token
            },
            async: false,
            success: function (data) {
                var fragment = document.createElement('div');
                fragment.innerHTML = data;

                var $basket = $('form[data-muifrm="basket"]');

                $basket.off();
                $basket.find(':input[data-muiaction="updatequantity"]').off();

                $basket.replaceWith(fragment.innerHTML);

                Init();
                MUI.Basket.init();

                basketFormInit();

                event.stopPropagation();
            }
        });
    }

    function DiscountForGift(frmRef, tablRow, quantity) {

        var sku = tablRow.find('input[name="sku"]').val();
        if (!sku)
            return;

        var $numberProductsForDiscount = tablRow.find('#numberProductsForDiscount');
        var $isDiscountApply = tablRow.find('#isDiscountApply');

        var numberProductsForDiscount = parseInt($numberProductsForDiscount.val());

        if (quantity < numberProductsForDiscount && $isDiscountApply.val() === 'False') {
            return;
        }

        if (quantity >= numberProductsForDiscount && $isDiscountApply.val() === 'True') {
            return;
        }

        var token = frmRef.find('input[name="__RequestVerificationToken"]').val();

        $.ajax({
            url: '/umbraco/Surface/Discount/UpdateGiftProduct',
            type: 'PATCH',
            data: {
                sku,
                quantity,
                __RequestVerificationToken: token
            },
            async: false,
            success: function (data) {
                var tBody = tablRow.parent()[0];
                var giftItem = frmRef.find(`#${data.Model.Key}`);

                if (data.IsConditionsFulfilled) {
                    $isDiscountApply.val('True');

                    if (data.IsGiftItemExist && giftItem.length === 0) {
                        var html = basketItemTemplate(data.Model);
                        $(html).appendTo(tBody);
                    }

                    return;
                }

                if (!data.IsGiftItemExist) {
                    giftItem.remove();
                }

                $isDiscountApply.val('False');
            }
        });
    }

    function DiscountForWholesale(frmRef, tablRow, quantity) {

        var totalOldPrice = tablRow.find('#total-old-price');
        var priceWithoutDiscount = parseFloat(tablRow.find('#old-price').text()) * quantity;

        if (totalOldPrice.length > 0) {
            $(totalOldPrice).html(priceWithoutDiscount % 1 == 0 ? priceWithoutDiscount.toFixed(0) : priceWithoutDiscount.toFixed(2));
        }

        var sku = tablRow.find('input[name="sku"]').val();
        if (!sku)
            return;

        var $numberProductsForDiscount = tablRow.find('#numberProductsForDiscount');
        var $isDiscountApply = tablRow.find('#isDiscountApply');

        var numberProductsForDiscount = JSON.parse($numberProductsForDiscount.val());

        if (quantity < numberProductsForDiscount && $isDiscountApply.val() === 'False') {
            return;
        }

        var token = frmRef.find('input[name="__RequestVerificationToken"]').val();

        $.ajax({
            url: '/umbraco/Surface/Discount/UpdatePrice',
            type: 'PATCH',
            data: {
                sku,
                quantity,
                __RequestVerificationToken: token
            },
            async: false,
            success: function (data) {

                var price = tablRow.find('#price');
                if (price.length > 0) {
                    const itemPrice = convertPriceByCurrency(data.Item.Price);
                    $(price).html(itemPrice);
                }

                $numberProductsForDiscount.val(data.Item.Quantity);
                var oldPrice = tablRow.find('#old-price').parent();
                var totalPrice = tablRow.find('#total-price').parent();

                if (!data.IsConditionsFulfilled) {
                    price.parent().removeClass("new-price");
                    totalPrice.removeClass("new-price");

                    oldPrice.hide();
                    totalOldPrice.parent().hide();

                    $isDiscountApply.val('False');

                    return;
                }

                $isDiscountApply.val('True');

                price.parent().addClass("new-price");
                totalPrice.addClass("new-price");

                oldPrice.show();
                totalOldPrice.parent().show();
            }
        });
    }
}
